var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.812 9C0.725387 9 0.644187 8.96752 0.5684 8.90256C0.50344 8.8376 0.47096 8.7564 0.47096 8.65896C0.47096 8.56152 0.508853 8.46408 0.58464 8.36664L3.4104 4.68016L0.76328 1.18856C0.687493 1.10195 0.6496 1.00451 0.6496 0.89624C0.6496 0.7988 0.68208 0.7176 0.74704 0.65264C0.812 0.58768 0.8932 0.555199 0.99064 0.555199H1.81888C1.98128 0.555199 2.12203 0.641813 2.24112 0.81504L4.40104 3.62456L6.56096 0.83128C6.62592 0.744666 6.68547 0.679706 6.7396 0.636399C6.80456 0.582266 6.88576 0.555199 6.9832 0.555199H7.77896C7.8764 0.555199 7.9576 0.58768 8.02256 0.65264C8.08752 0.7176 8.12 0.7988 8.12 0.89624C8.12 1.00451 8.08211 1.10195 8.00632 1.18856L5.32672 4.71264L8.15248 8.36664C8.22827 8.46408 8.26616 8.56152 8.26616 8.65896C8.26616 8.7564 8.23368 8.8376 8.16872 8.90256C8.10376 8.96752 8.02256 9 7.92512 9H7.0644C6.902 9 6.76125 8.9188 6.64216 8.7564L4.36856 5.78448L2.06248 8.7564C1.99752 8.83219 1.93256 8.89173 1.8676 8.93504C1.81347 8.97835 1.73768 9 1.64024 9H0.812Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusFailed);
export default __webpack_public_path__ + "static/media/status-failed.2eb875b06e7b7dcc179dc605488372e7.svg";
export { ForwardRef as ReactComponent };